import * as Immutable from 'immutable';
import * as t from 'io-ts';

import { Action, ImmutableInterface } from '../../../types/';
import { AlphasCorrelationFailureAction, CorrelationSelf } from '../../AlphasReducer/AlphasReducer.types';
import { AlphasListingData } from '../../AlphasReducer/AlphasReducer.types';
import { AlphaPropertiesStoreElement } from '../../AlphaPropertiesReducer/AlphaPropertiesReducer.types';

export interface DataAction {
  tabIndex: number;
  indexChild?: number;
  childId?: string;
  alpha?: any;
  data?: any;
  chartType?: string;
  isMulti?: boolean;
  idParent?: any;
  idChilds: any[];
  date: any;
  selection: string;
  delay: string;
  region: string;
  instrumentType: string;
  selectionLimit: string;
  selectionHandling: string;
  source: number;
  destination: number;
  currentActiveTab: number;
  nextStatus: any;
  currentStatus: any;
  isTutorialModeActive?: boolean;
  tutorialStep?: number;
}

export interface BaseDataStore {
  data: DataStoreList;
}

export type DataStore = ImmutableInterface<BaseDataStore>;

export interface BaseDataStoreElement {
  selectionCodeFetching?: boolean;
  alphasFromSelectionCode?: any;
  alphaDetail?: any;
  fetchingData?: boolean;
  children?: any;
  fetchingCheck?: boolean;
  fetchingRecordSetsChart?: boolean;
  fetchingRecordSets?: boolean;
  chartData?: any;
  recordsSets?: any;
  fetchingCorrelation?: boolean;
  fetchingCorrelationProd?: boolean;
  chartType: string;
  summaryIsOpen: boolean;
  alphaProperties: AlphaPropertiesStoreElement;
  superAlpha: boolean;
  fetchingAlphaFilters: boolean;
  alphaFilters: t.TypeOf<typeof AlphasListingData>;
  selectionCodeSettings: {
    selection: string;
    delay: string;
    region: string;
    instrumentType: string;
    selectionLimit: string;
    selectionHandling: string;
  };
  status: string;
  statusAfterSimulation?: string;
}

export type DataStoreList = Immutable.List<DataStoreElement>;

export type DataStoreElement = ImmutableInterface<BaseDataStoreElement>;

export type DataActionType = Action<DataAction>;

export type CorrelationFailureDataActionType = Action<DataAction & AlphasCorrelationFailureAction>;

export const ParametersOptional = t.partial({
  limit: t.any,
  value: t.any,
});

export const ParametersMandatory = t.interface({
  name: t.string,
  result: t.string,
});

export const Parameters = t.intersection([ParametersMandatory, ParametersOptional]);

const ChecksData = t.type({
  checks: t.array(Parameters),
});

const SelfCorrelationData = t.partial({
  selfCorrelation: CorrelationSelf,
});

export const Checks = t.intersection([ChecksData, SelfCorrelationData]);

export const Records = t.interface({
  records: t.array(t.array(t.union([t.string, t.number, t.null]))),
});

export const Properties = t.interface({
  type: t.string,
  name: t.string,
  title: t.string,
});

export const Schema = t.interface({
  schema: t.interface({
    properties: t.array(Properties),
  }),
});

export const Details = t.partial({
  details: t.intersection([Records, Schema]),
});

export const InSample = t.interface({
  is: t.intersection([Checks, Details]),
});

export const CheckSubmissionValidation = t.interface({
  is: Checks,
});

export const DataAlpha = InSample;
